import Base from '../Base';
import styles from './Layout.module.scss';

const Layout = ({ children }) => {
  return (
    <Base>
      <div className={styles.root}>
        {children}
      </div>
    </Base>
  );
};

export default Layout;